import {isInstanceOf, isPlainObject} from 'rlink-type-utils';

/**
 * Returns the number of values that can be iterated over for
 * the given object.
 *
 * @param  {IterableCollection} obj
 * @return {number}
 */
export default function count (obj) {
  if (!this.isIterable(obj)) {
    throw new Error(`Cannot count non-iterable object: ${obj}`);
  }
  if (isInstanceOf(obj.length, Number)) {
    return obj.length;
  } else if (isInstanceOf(obj.size, Number)) {
    return obj.size;
  } else if (isInstanceOf(obj.count, Function)) {
    return obj.count();
  } else if (isPlainObject(obj)) {
    let size = 0;
    //eslint-disable-next-line no-unused-vars
    for (let k in obj) {
      size++;
    }
    return size;
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/count.js